import { Component, computed, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'pu-user-status',
  template: '{{ fullKey() | translate }}',
  styleUrls: ['./user-status.component.scss'],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class UserStatusComponent {
  type = input<string>('');
  i18nPrefix = input<string>('');

  readonly fullKey = computed(() => {
    const prefix = this.i18nPrefix() ?? '';
    const t = this.type() ?? '';
    return `${prefix}.${t}`;
  });

  readonly hostClasses = computed(() => {
    const t = this.type() ?? '';
    return `pu-user-status pu-user-status_${t}`;
  });
}
